export default __webpack_public_path__ + "static/lady-ebd0da4195c8da903a958f783fe33008.svg";